import { signInAnonymously, User } from 'firebase/auth';
import { getFirebaseInstances } from './config';
import { logger } from '@/utils/logger';

/**
 * 匿名認証でサインイン
 */
export async function signInAnonymous(): Promise<User | null> {
  const firebase = getFirebaseInstances();
  if (!firebase) {
    logger.warn('Firebase is not initialized');
    return null;
  }

  try {
    const userCredential = await signInAnonymously(firebase.auth);
    logger.log('Signed in anonymously:', userCredential.user.uid);
    return userCredential.user;
  } catch (error) {
    logger.error('Anonymous sign-in error:', error);
    return null;
  }
}

/**
 * 現在のユーザーを取得
 */
export function getCurrentUser(): User | null {
  const firebase = getFirebaseInstances();
  if (!firebase) {
    return null;
  }
  return firebase.auth.currentUser;
}

/**
 * 認証状態の変更を監視
 */
export function onAuthStateChanged(callback: (user: User | null) => void): (() => void) | null {
  const firebase = getFirebaseInstances();
  if (!firebase) {
    return null;
  }

  const unsubscribe = firebase.auth.onAuthStateChanged(callback);
  return unsubscribe;
}
